(function($) {
  function formatMoney(value) {
    var money_format = $('[data-money-format]').data('money-format') || '${{amount}}';
    return Shopify.formatMoney(value, money_format).replace('.00', '');
  }
  
  function addItemToCart(p_options) {
    var data = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
    };

    if (p_options.properties !== undefined) {
      data['properties'] = p_options.properties;
    }
    console.log(data);

    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });     
  };
  
  function refreshCart() {
    $.getJSON('/cart.js').then(function(cart) {
      $('.cart_count').text(cart.item_count);
    });
  }
  
  function updatePrices() {
    var $product = $('.product-' + product.id);    
    $product.find('.variant-price').text(formatMoney(product.selected_variant.price));

    var frame_price = frame_product.selected_variant ? frame_product.selected_variant.price : 0;
    $product.find('.frame-price').text('+' + formatMoney(frame_price));
    
    var total_price = product.selected_variant.price + frame_price;
    $product.find('.total-price').text(formatMoney(total_price));
    $('.product-form-sticky').find('.total-price').text(formatMoney(total_price));
    
    var $product_options_main = $('.product-options-main');
    var compare_price = '';
    if (product.selected_variant.compare_at_price > product.selected_variant.price) {
      compare_price = '<span class="variant-price compare-price">' + formatMoney(product.selected_variant.compare_at_price) + '</span>';
    }
    var price = '<span class="variant-price' + (compare_price? ' sale-price' : '') + '">' + formatMoney(product.selected_variant.price) + '</span>';
    $product_options_main.find('.option_title').html('<span>Size</span>' + price  + compare_price);    
  }
  
  function initTabs() {
    function openTab(tab) {
      var $tabContentWrapper = $('.size-guide-frame-details .block-content-wrapper');
      var $tab = $('.size-guide-frame-details .block[data-type="' + tab + '"]');
      var $tabContent = $('.size-guide-frame-details .block-content[data-type="' + tab + '"]');
      
      $tab.addClass('active');
      $tabContent.addClass('active');
      
      $tabContentWrapper.addClass('active');
    }
    
    // tab click
    $(document).on('click', '.size-guide-frame-details .block', function(e) {
      var $tab = $(e.currentTarget);
      var tab = $tab.data('type');
      var $activeTabContent = $('.size-guide-frame-details .block-content.active');
      
      $('.size-guide-frame-details .block').removeClass('active');
      $('.size-guide-frame-details .block-content').removeClass('active');      
      
      openTab(tab);
    });
    
    // tab close
    $(document).on('click', '.size-guide-frame-details .block .icon-close', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      $('.size-guide-frame-details .block-content-wrapper').removeClass('active');
      $('.size-guide-frame-details .block').removeClass('active');
      $('.size-guide-frame-details .block-content').removeClass('active');      
    });
  }
  
  function updateFrameVariant() {
    var selected_frame_finish = $('[name=frame-finish]:checked').val()
    frame_product.selected_variant = frame_product.variants.find(function(v) {
      var frame_size = v.option1.replace(/"/g, '');
      return product.selected_variant.option1.indexOf(frame_size) !== -1 && v.option2 == selected_frame_finish;
    });
    //console.log(frame_product.selected_variant, product.selected_variant);
    
    // change sticky form frame
    var $sticky_form = $('.product-form-sticky');
    if ($sticky_form.find('#frame').val() !== selected_frame_finish) {
      $sticky_form.find('#frame').val(selected_frame_finish);
      $sticky_form.find('#frame').selectric('refresh');
    }      
  }  
    
  function initStickyForm() {
    var $sticky_form = $('.product-form-sticky');
    
    var selectric_options = {};
    $sticky_form.find('select').selectric(selectric_options);
    
    // on scroll show sticky form
    $(window).on('scroll', function(e) {
      var $form = $('.product_form');
      var offset = 50;
      var isFormInView = window.pageYOffset > ($form.offset().top + offset);
      $sticky_form[isFormInView ? 'addClass' : 'removeClass']('active');
    });
    
    // size selection
    $(document).on('change', '.product-form-sticky .size-options select', function(e) {
      //console.log(e);
      var $select = $(e.currentTarget);
      product.selected_variant = product.variants.find(function(v) {
        return v.id == $select.val();
      });
      
      // change product form variant
      var $product_form = $('.shopify-product-form');
      if ($product_form.find('input[name=option-0]:checked').val() !== product.selected_variant.id) {
        $product_form.find('input[name=option-0][value="' + product.selected_variant.option1 + '"]').prop('checked', true);
      }
      
      updateFrameVariant();
      
      updatePrices();
    });
    
    // frame selection
    $(document).on('change', '.product-form-sticky .frame-options select', function(e) {
      //console.log(e);
      var $select = $(e.currentTarget);
      
      // change product form variant
      var $product_form = $('.shopify-product-form');
      if ($product_form.find('input[name=frame-finish]:checked').val() !== $select.val()) {
        $product_form.find('input[name=frame-finish][value="' + $select.val() + '"]').prop('checked', true).trigger('change');
      }      
    });    
  }
  
  function initProduct() {
    // Option title
    var $product_options_main = $('.product-options-main');
    $product_options_main.find('.swatch_options').prepend($product_options_main.find('.option_title'));
    
    updatePrices();
    
    // Remove price from labels
    $('.swatch-element').each(function() {
      var $label = $(this).find('label');
      var label = $label.text();
      if (label.split('(').length) {
        $label.text(label.split('(')[0]);
      }
    });
    
    // product variant change
    var $product = $('.product-' + product.id);
    $product.on('variant-change', function(e) {
      //console.log(e);
      product.selected_variant = product.variants.find(function(v) {
        return v.id == e.variant.id;
      });
      
      // change sticky form variant
      var $sticky_form = $('.product-form-sticky');
      if ($sticky_form.find('#size').val() !== product.selected_variant.id) {
        $sticky_form.find('#size').val(product.selected_variant.id);
        $sticky_form.find('#size').selectric('refresh');
      }      
      
      updateFrameVariant();      
      updatePrices();
    });
    
    // on frame selection
    $(document).on('change', '[name=frame-finish]', function(e) {
      updateFrameVariant();      
      updatePrices();
    });
    
    initTabs();
    
    initStickyForm();
    
    // return to top
    $(document).on('click', '.return-to-top', function(e) {
      e.preventDefault();
      $('html,body').animate({scrollTop: 0}, 1000);
    });
    
    function addFormToCart($form) {
      if (frame_product.selected_variant) {
        addItemToCart({
          variant_id: frame_product.selected_variant.id,
          quantity: 1
        })
        .then(function(data) {
          $form.submit();
          refreshCart();
        })
        .catch(function(error) {
          console.error(error);
        });
      }
      else {
        $form.submit();
      }      
    }
    
    // Add to Cart (main)
    $(document).on('click', '.shopify-product-form .add_to_cart', function(e) {
      e.preventDefault();
      var $add_to_cart = $(e.currentTarget);
      var $form = $add_to_cart.closest('form');
      addFormToCart($form);
    });
    
    // Add to Cart (sticky form)
    $(document).on('click', '.product-form-sticky .add_to_cart', function(e) {
      e.preventDefault();
      var $form = $('.shopify-product-form');
      
      addFormToCart($form);      
    });
  }
  
  $(document).ready(function() {
    console.log('READY');
    initProduct();
  });
})(jQuery);